import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { fetchTjenesteTekster } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import { fetchResources, getResourcesFromState } from '@helsenorge/framework-utils/resources';
import HjelpeskuffComponent from './hjelpeskuff-component';
import { toggleShowHjelpeskuff, hideHjelpeskuff, showHjelpeskuff, getDefaultTekst, getSeksjonTekst, removeSeksjonTekst, toggleExpanded, toggleShowHelpItem, addHjelpetrigger, removeHjelpetrigger, } from './hjelpeskuff-state';
import { getResources, Projects } from '../../resources';
export const TriggerHelpItemEvent = 'HN-trigger-help-item';
export const AddHjelpetrigger = 'HN-add-hjelpetrigger';
export const RemoveHjelpetrigger = 'HN-remove-hjelpetrigger';
class HjelpeskuffContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleAddHjelpetriggerEvent = this.handleAddHjelpetriggerEvent.bind(this);
        this.handleRemoveHjelpetriggerEvent = this.handleRemoveHjelpetriggerEvent.bind(this);
        this.handleTriggerHelpEvent = this.handleTriggerHelpEvent.bind(this);
    }
    componentDidMount() {
        if (this.props.mount) {
            this.props.mount();
        }
        window.addEventListener(AddHjelpetrigger, this.handleAddHjelpetriggerEvent);
        window.addEventListener(RemoveHjelpetrigger, this.handleRemoveHjelpetriggerEvent);
        window.addEventListener(TriggerHelpItemEvent, this.handleTriggerHelpEvent);
    }
    componentWillUnmount() {
        window.removeEventListener(AddHjelpetrigger, this.handleAddHjelpetriggerEvent, false);
        window.removeEventListener(RemoveHjelpetrigger, this.handleRemoveHjelpetriggerEvent, false);
        window.removeEventListener(TriggerHelpItemEvent, this.handleTriggerHelpEvent, false);
    }
    handleAddHjelpetriggerEvent(event) {
        if (event.detail && this.props.addHjelpetrigger) {
            const triggerComponentId = event.detail.triggerComponentId;
            this.props.addHjelpetrigger(triggerComponentId);
        }
    }
    handleRemoveHjelpetriggerEvent(event) {
        if (event.detail && this.props.removeHjelpetrigger) {
            const triggerComponentId = event.detail.triggerComponentId;
            this.props.removeHjelpetrigger(triggerComponentId);
        }
    }
    handleTriggerHelpEvent(event) {
        if (event.detail && this.props.triggerHelpItem) {
            const hjelpetekstId = event.detail.hjelpetekstId;
            const tjenesteNavn = event.detail.tjenesteNavn;
            const triggerComponentId = event.detail.triggerComponentId;
            this.props.triggerHelpItem(hjelpetekstId, tjenesteNavn, triggerComponentId);
        }
    }
    render() {
        const { triggerComponentIds, mount, ...other } = this.props;
        if (!this.props.resources || (!this.props.defaultSeksjon && this.props.seksjoner && this.props.seksjoner.length === 0)) {
            return null;
        }
        return (_jsx("div", { children: _jsx(HjelpeskuffComponent, { ...other }) }));
    }
}
function mapStateToProps(state, props) {
    const tjenesteNavn = props.tjenesteNavn ?? getPath();
    const defaultSeksjon = getDefaultTekst(state, tjenesteNavn, props.hjelpetekstId);
    const seksjoner = (state.hjelpeskuff.seksjoner?.map(seksjon => getSeksjonTekst(state, seksjon))?.filter(s => s != null) ??
        []);
    return {
        activeSeksjonId: state.hjelpeskuff.activeSeksjonId,
        seksjoner,
        defaultSeksjon,
        isOpen: state.hjelpeskuff.isOpen,
        triggerComponentIds: state.hjelpeskuff.triggerComponentIds,
        resources: getResourcesFromState(state, Projects.FRAMEWORK),
    };
}
function mapDispatchToProps(dispatch, props) {
    return {
        mount: () => {
            dispatch(fetchResources({ project: Projects.FRAMEWORK, language: props.language, getResources }));
            dispatch(fetchTjenesteTekster({ name: props.tjenesteNavn ?? getPath(), language: props.language }));
        },
        toggleExpanded: (hjelpetekstId, tjenesteNavn) => {
            dispatch(toggleExpanded(hjelpetekstId, tjenesteNavn));
        },
        toggleShowHjelpeskuff: () => {
            dispatch(toggleShowHjelpeskuff());
        },
        hideHjelpeskuff: () => {
            dispatch(hideHjelpeskuff());
        },
        showHjelpeskuff: () => {
            dispatch(showHjelpeskuff());
        },
        removeSeksjon: (hjelpetekstId, tjenesteNavn) => {
            dispatch(removeSeksjonTekst(hjelpetekstId, tjenesteNavn));
        },
        triggerHelpItem: (hjelpetekstId, tjenesteNavn, triggerComponentId) => {
            dispatch(toggleShowHelpItem(triggerComponentId ? triggerComponentId : '', hjelpetekstId, tjenesteNavn ?? ''));
        },
        addHjelpetrigger: (triggerComponentId) => {
            dispatch(addHjelpetrigger(triggerComponentId ? triggerComponentId : ''));
        },
        removeHjelpetrigger: (triggerComponentId) => {
            dispatch(removeHjelpetrigger(triggerComponentId ? triggerComponentId : ''));
        },
        language: props.language,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HjelpeskuffContainer);
